import { CSSProperties } from "react";
import CardSymphony from "elements/CardSymphony";
import useWebsiteBuilder, { TourStyle, WebsiteBuilder_tourExists } from "Hooks/useWebsiteBuilder";
import TourSetupSection from "pages/WebsitePage/components/CustomizeWebsite/components/SetupSection/TourSetupSection";
import WebsiteBuilderHeader from "../WebsiteBuilderHeader";
import { clsx, styx } from "modules/Utils";
import OptionsSymphony, { OptionItem } from "elements/OptionsSymphony";
import WebsiteBuilderFooter from "../WebsiteBuilderFooter";
import { BoxesWebsiteLayoutIcon, StackedWebsiteLayoutIcon } from "components/svg-icons/website/themes/icons";

interface TourContentProps {
    className: string;
    contentIndex: number;
    tabSelectorComponent: React.ReactNode;
    id: string;
}

const TourContent = ({
    className,
    contentIndex,
    tabSelectorComponent,
    id,
}: TourContentProps) => {
    const {
        websiteContent,
        setWebsiteContent,
    } = useWebsiteBuilder() as WebsiteBuilder_tourExists;

    const tourContent = websiteContent[contentIndex].tourContent;

    const TOUR_STYLE_OPTIONS: OptionItem[] = [
        {
            id: TourStyle.BOXES,
            label: 'Boxes',
            childrenLeft: (
                <BoxesWebsiteLayoutIcon
                    width={30}
                    height={30}
                    selected={tourContent.style === TourStyle.BOXES}
                />
            ),
        },
        {
            id: TourStyle.STACKED,
            label: 'Stacked',
            childrenLeft: (
                <StackedWebsiteLayoutIcon
                    width={30}
                    height={30}
                    selected={tourContent.style === TourStyle.STACKED}
                />
            ),
        },
    ]

    // NOTE: render()
    return (
        <CardSymphony
            className={clsx("tourContentComponent", className)}
            style={styx(sty.tourContentComponent)}
            size="small"
            id={id}
        >
            <WebsiteBuilderHeader
                contentIndex={contentIndex}
                rightSideContent={
                    <>
                        {tabSelectorComponent}
                    </>
                }
            />

            <TourSetupSection
                contentIndex={contentIndex}
                isNoPadding
                isWebsiteBuilder
            />

            <WebsiteBuilderFooter
                className="tourContentFooter"
                contentIndex={contentIndex}
                isBackgroundColor
                isSecondaryColor
                isTextColor
                isTextSecondaryColor
                styleOptions={
                    <OptionsSymphony
                        className="tourStyleOptions"
                        style={{ flexWrap: 'wrap' }}
                        options={TOUR_STYLE_OPTIONS}
                        value={tourContent.style || ''}
                        handleOptionSelected={(option) => {
                            const updatedContent = [...websiteContent];
                            updatedContent[contentIndex].tourContent.style = option as TourStyle;
                            setWebsiteContent(updatedContent);
                        }}
                        size="small"
                        isRadio={false}
                        childrenLeftOffset={-8}
                    />
                }
            />
        </CardSymphony>
    )
}

const sty: Record<string, CSSProperties> = {
    tourContentComponent: {
        width: '100%',
    }
}

export default TourContent;